<template>
  <v-dialog
    v-model="isVisible"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="CloseDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Reports</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- any button if you want here -->
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="8" md="4" lg="4">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="DateFromFormat"
                    clearable
                    label="From"
                    readonly
                    v-on="on"
                    color="primary"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  v-model="dateFrom"
                  @change="getLineChartData"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="8" md="4" lg="4">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="DateToFormat"
                    clearable
                    label="To"
                    readonly
                    v-on="on"
                    color="primary"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  v-model="dateTo"
                  @change="getLineChartData"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>

        <v-layout>
          <v-flex xs12 sm12 md12>
             
            <line-chart
              v-if="loaded"
              :chartdata="chartdata"
              :options="lineOptions"
              :styles="myStyles"
            />
            TOTAL : {{ total }}
          </v-flex>
         
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
// import LineChart  from "../Charts/Linechart.vue";

import axios from "axios";
export default {
  components: {
    LineChart: () => import("../main/charts/Linechart.vue"),
  },
  data() {
    return {
      isVisible: false,
      dateFrom: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      appointmentData: null,
      loaded: false,
      chartdata: null,
      total: 0,
      labels: [],
      lineOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {},
  methods: {
    getLineChartData() {
      this.labels = this.GetLabels();
      this.menu1 = false;
      this.menu2 = false;
      this.loaded = false;
      var queryString = `query reportForCurrentCompanyAppointments($companyId: String!, $datefrom: DateTime!, $dateto: DateTime!){
                        reportForCurrentCompanyAppointments(companyId: $companyId, datefrom: $datefrom, dateto: $dateto){
                              startTimeStamp,
                        }
                    }`;

      axios
        .post("/graphql", {
          query: queryString,
          variables: {
            companyId: this.$store.getters.user.details.companyId,
            datefrom: this.dateFrom,
            dateto: this.dateTo,
          },
        })
        .then((result) => {
          this.appointmentData =
            result.data.data.reportForCurrentCompanyAppointments;
          if (this.appointmentData) {
            let data = [];

            this.labels.forEach((label) => {
              let count = 0;

              this.appointmentData.forEach((ad) => {
                let appointmentDate = this.$moment(ad.startTimeStamp).format(
                  "MMM-DD"
                );

                if (appointmentDate === label) {
                  count++;
                }
              });
              data.push(count);
            });
            this.total = 0;
            data.forEach(d => this.total += d);
            this.chartdata = {
              labels: this.GetLabels(),
              datasets: [
                {
                  label: "Appointments / period",
                  data: data,
                  backgroundColor: ["rgba(255, 99, 132, 0.2)"],
                  borderColor: ["rgba(255, 99, 132, 1)"],
                  borderWidth: 1,

                  // Changes this dataset to become a line
                  type: "line",
                },
              ],
            };

            this.loaded = true;
          } else {
            this.showError("Could not find any related resource!");
          }
        })
        .catch(() => {
          this.showError("Something went wrong while getting chart data!");
        });
    },
    getData(data) {
      if (!data) return;
      let appointments = [];
      let labels = this.GetLabels();
      labels.forEach((label) => {
        data.forEach((appointment) => {
          let appDate = this.$moment(appointment.startdatetime);
          if (label === appDate.format("MMM-DD")) {
            appointments.push(appointment);
          }
        });
      });
      return appointments;
    },
    OpenDialog() {
      this.isVisible = true;
      (this.dateFrom = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10)),
        (this.dateTo = new Date().toISOString().substr(0, 10)),
        this.getLineChartData();
    },
    CloseDialog() {
      this.isVisible = false;
      this.dateFrom = null;
      this.dateTo = null;
      this.loaded = false;
    },
    GetXData() {
      let dates = [];
      let currentDay = this.$moment(this.dateFrom);
      do {
        dates.push(currentDay);
        currentDay = this.$moment(currentDay).add(1, "days");
      } while (currentDay < this.$moment(this.dateTo).add(1, "days"));
      return dates;
    },
    GetLabels() {
      let dates = this.GetXData();
      return dates.map((d) => {
        return d.format("MMM-DD");
      });
    },
  },
  computed: {
    DateFromFormat() {
      return this.dateFrom
        ? this.$moment(this.dateFrom).format("MMMM DD YYYY")
        : "";
    },
    DateToFormat() {
      return this.dateTo
        ? this.$moment(this.dateTo).format("MMMM DD YYYY")
        : "";
    },
    getDateFrom() {
      return this.dateFrom;
    },
    getDateTo() {
      return this.dateTo;
    },
    myStyles() {
      return {};
    },
  },
};
</script>
